import React from 'react';
import { Card } from '@mui/material';
import colors from 'assets/theme/base/colors';
import MDBox from 'components/atoms/MDBox/MDBox';
import {
  containerStyles,
} from 'helpers/helpers';
import { Shadows } from 'models/StyleModels';
import { loadingAnimation } from 'assets/animations/animationStyles';

interface JointOutcomesCardLoaderProps {
  displayVertical: boolean;
}

const JointOutcomesCardLoader: React.FC<JointOutcomesCardLoaderProps> = ({ displayVertical }) => (
  <MDBox
    shadow={Shadows.SMALL}
    {...containerStyles({
      flexDirection: 'column',
      height: 'fit-content',
      borderRadius: '8px',
      overflow: 'hidden',
    })}
  >
    <MDBox {...containerStyles({
      width: '100%',
      height: '3.1rem',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: colors.secondary.focus,
      padding: '.5rem 1rem',
      ...loadingAnimation('backgroundColor', colors.grey[400], colors.grey[500]),
    })} />
    <MDBox
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '1rem',
      }}
    >
      <MDBox
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: displayVertical ? 'column' : 'row',
          justifyContent: 'center',
          padding: '.5rem',
          textAlign: 'center',
          height: '3.06rem',
          ...loadingAnimation('backgroundColor'),
        }}
      />
    </MDBox>
    <MDBox
      sx={{
        width: '100%',
        backgroundColor: colors.white.main,
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem',
        gap: '.5rem',
      }}
    >
      <MDBox
        shadow={Shadows.MEDIUM}
        {...containerStyles({
          height: '2.5rem',
          padding: '.25rem',
          display: 'flex',
          flexDirection: displayVertical ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          position: 'relative',
          backgroundColor: colors.grey[100],
          overflow: 'hidden',
          borderRadius: '8px',
          textAlign: 'center',
          ...loadingAnimation('backgroundColor'),
        })}
      />
      <MDBox {...containerStyles({
        width: '100%',
        display: 'flex',
        gap: '.5rem',
        flexDirection: displayVertical ? 'column' : 'row',
        alignItems: displayVertical ? 'flex-start' : 'center',
      })}>
        <Card
          {...containerStyles({
            width: displayVertical ? ' 100%' : '50%',
            height: '15rem',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            overflow: 'hidden',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            color: colors.white.main,
            ...loadingAnimation('backgroundColor'),
          })}
        />
        <Card
          {...containerStyles({
            width: displayVertical ? ' 100%' : '50%',
            height: '15rem',
            display: 'flex',
            borderRadius: '8px',
            border: '5px solid transparent',
            overflow: 'hidden',
            backgroundColor: colors.grey[300],
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            ...loadingAnimation('backgroundColor'),
          })}
        />
      </MDBox>
    </MDBox>
    <MDBox {...containerStyles({
      width: '100%',
      height: '3.75rem',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: colors.disabled.focus,
      padding: '.75rem 1rem',
      ...loadingAnimation('backgroundColor'),
    })} />
  </MDBox>
);

export default JointOutcomesCardLoader;